module.exports = __webpack_public_path__ + "img/2.afec7091.jpg";